import { createApp } from 'vue';
import routes from './router';
import { createRouter, createWebHistory } from "vue-router";
import VueClickAway from "vue3-click-away";
import Vue3TouchEvents from "vue3-touch-events";
import Popper from "vue3-popper";
import {store} from './store';
import App from './App.vue';
import 'theme/moydom/less/pages/spravochnik.less';
import 'theme/moydom/less/pages/digital-twin/index.less';
import 'theme/moydom/less/blocks/swiper/top-list.less';
import axios from 'axios';

const app = createApp({
    components: {App},
    template: '<app />'
});

const router = createRouter({
    history: createWebHistory('/spravochnik'),
    routes: routes,
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
});

app.use(store);
app.use(router);
app.use(VueClickAway);
app.use(Vue3TouchEvents);
app.component("Popper", Popper);
app.mount('#app');
